import { MenuOutlined, CloseOutlined } from '@ant-design/icons';
import { useState } from 'react';

import Link from './Link';
import './TopBar.css';

import img_wk_logo from '../assets/img_wk_logo.png';
import { CONTACT_URL } from '../data/url';

const TopBar = () => {
    const [menuOpened, setMenuOpened] = useState(false);

    const scrollToAnchor = (anchor: string) => {
        const target = document.getElementById(anchor);
        target?.scrollIntoView({ behavior: 'smooth' });
    };

    const onMenuItemClick =  () => setMenuOpened(false);

    return (
        <div className='top_bar'>
            <div className='logo' onClick={() => {window.location.reload();window.scrollTo({ top: 0 });}}>
                <img src={img_wk_logo} alt='img_wk_logo'/>
            </div>
            <div className='menu_desktop'>
                <Link onClick={() => scrollToAnchor('feature')}>產品特色</Link>
                <Link onClick={() => scrollToAnchor('solution')}>企業方案</Link>
                <Link onClick={() => scrollToAnchor('case')}>企業案例</Link>
                <Link onClick={() => scrollToAnchor('faq')}>常見問題</Link>
                <Link href={CONTACT_URL} newTab>聯絡我們</Link>
            </div>
            <div className='menu_mobile'>
                <div onClick={() => setMenuOpened(!menuOpened)}>
                    {menuOpened ? <CloseOutlined/> : <MenuOutlined/>}
                </div>
            </div>
            {menuOpened ? (
                <div className='mobile_dopdown_menu'>
                    <div><Link onClick={() => {onMenuItemClick();scrollToAnchor('feature');}}>產品特色</Link></div>
                    <div><Link onClick={() => {onMenuItemClick();scrollToAnchor('solution');}}>企業方案</Link></div>
                    <div><Link onClick={() => {onMenuItemClick();scrollToAnchor('case');}}>企業案例</Link></div>
                    <div><Link onClick={() => {onMenuItemClick();scrollToAnchor('faq');}}>常見問題</Link></div>
                    <div><Link href={CONTACT_URL} newTab onClick={onMenuItemClick}>聯絡我們</Link></div>
                </div>
            ) : null}
        </div>
    );
};

export default TopBar;
